import Glide from '@glidejs/glide';
import {OfferClickManager} from '../../front/domains/offer/offerClickManager';
import {ReadyProvider} from '../providers/readyProvider';
import OfferViewFacade from '../../front/domains/offer/offerViewFacade';

class BigSlider
{
    /**
     * @param {String} selector
     */
    static init(selector) {
        let element = document.querySelector(selector);

        if (!element) {
            return;
        }

        let glide = new Glide(selector, {
            type: 'carousel',
            startAt: 0,
            perView: 1,
            autoplay: 5000,
            hoverpause: true,
        }).mount();

        Array.from(element.querySelectorAll('[data-glide-dir]')).forEach((element) => {
            element.addEventListener('click', (event) => glide.go(event.target.getAttribute('data-glide-dir')));
        });

        OfferClickManager.init(element);
        OfferViewFacade.notifyAboutAllAvailable(element);
    }
}

ReadyProvider.executeOnReady(() => BigSlider.init('[data-block="slider"][data-type="big"]'));
